module.exports = __webpack_public_path__ + "static/img/cool_test.e6ce37bd.png";